<template>
  <div>
    <b-row class="mb-1">
      <b-col cols="6">
        <h2>{{ $t('Threat Analytics') }}</h2>
      </b-col>
      <b-col cols="6">
        <b-row align-h="end" align-v="center">
          <TimeRangeSelector
            :minDate="minDate"
            :maxDate="maxDate"
            :initRange="timeRange"
            @change-time-range="updateStateTimeRange"
            class="mr-1"
          ></TimeRangeSelector>
        </b-row>
      </b-col>
    </b-row>
    <b-tabs lazy>
      <b-tab v-for="tab in tabs" :key="tab.key" :active="tab.key === defaultTab">
        <template #title>
          {{ tab.title }}
          <b-icon
            :icon="defaultTab === tab.key ? 'star-fill' : 'star'"
            class="ml-1 text-warning"
            @click.stop="setDefaultTab(tab.key)"
          />
        </template>
        <component :is="tab.component" :timeRange="timeRange" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import moment from 'moment';

import dateCeil from '@/xvisor/utilities/dateCeil';
import EndpointAnalyticsTabs from '@/xvisor/components/security/EndpointAnalyticsTabs.vue';
import SecurityOverviewTab from '@/xvisor/components/security/SecurityOverviewTab.vue';
import SecurityTabs from '@/xvisor/components/security/SecurityTabs.vue';
import TimeRangeSelector from '@/xvisor/components/TimeRangeSelector.vue';
import ThreatsTabs from '@/xvisor/components/security/ThreatsTabs.vue';

export default ({
  components: {
    SecurityOverviewTab,
    EndpointAnalyticsTabs,
    SecurityTabs,
    ThreatsTabs,
    TimeRangeSelector,
  },
  data() {
    const now = dateCeil(new Date());
    return {
      maxDate: now,
      minDate: moment(now).subtract(1, 'month').toDate(),

      /** The Time range for all components on the page. */
      timeRange: this.$store.state.app.timeRange,
      processInfo: [],
      loaded: false,
      defaultTab: 'overview',
      tabs: [
        { key: 'overview', title: 'Overview', component: 'SecurityOverviewTab' },
        { key: 'network', title: 'Network View', component: 'SecurityTabs' },
        { key: 'endpoint', title: 'Endpoint View', component: 'EndpointAnalyticsTabs' },
        { key: 'threats', title: 'Threats', component: 'ThreatsTabs' },
      ],
    };
  },
  mounted() {
    const defaultSecurityTab = localStorage.getItem('defaultSecurityTab');
    if (defaultSecurityTab) {
      this.defaultTab = defaultSecurityTab;
    }
  },
  methods: {
    updateStateTimeRange(timeRange) {
      this.$store.commit('app/UPDATE_TIME_RANGE', timeRange);
      this.timeRange = timeRange;
    },
    setDefaultTab(index) {
      this.defaultTab = index;
      localStorage.setItem('defaultSecurityTab', index);
    },
  },
});
</script>
